export enum GENDER {
  MALE = 'male',
  FEMALE = 'female',
}
